
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.242 12.584l4.57-4.631-4.563-4.53a.9.9 0 111.268-1.278l5.2 5.162a.9.9 0 01.006 1.271l-5.2 5.27a.9.9 0 01-1.28-1.264z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    